import * as actions from '../../actions/actionTypes';

const initialState = 0;

export default function totalElements(state = initialState, action) {
  switch (action.type) {
    case actions.SET_FEEDS_HISTORY:
      return action.payload.totCnt;
    default:
      return state;
  }
}
